import { CalendarIcon, ClockIcon, UserIcon, MapPinIcon, EllipsisVerticalIcon } from '@heroicons/react/24/outline';

export default function DemoCard({ demo, onClick, onAction }) {
  const { payload } = demo || {};
  const { customer, dateTime, location } = payload || {};
  
  const formatDate = (dateString) => {
    if (!dateString) return 'N/A';
    const options = { year: 'numeric', month: 'long', day: 'numeric' };
    return new Date(dateString).toLocaleDateString('en-US', options);
  };

  const getTimeSlot = (timeSlot) => {
    const timeMap = {
      'Morning': '9:00 AM - 12:00 PM',
      'Afternoon': '1:00 PM - 4:00 PM',
      'Evening': '5:00 PM - 8:00 PM'
    };
    return timeMap[timeSlot] || timeSlot || 'N/A';
  };

  return (
    <div 
      className="bg-white rounded-lg shadow-sm border border-gray-200 overflow-hidden hover:shadow-md transition-shadow duration-200 cursor-pointer"
      onClick={onClick}
    >
      <div className="p-4">
        <div className="flex justify-between items-start">
          <div>
            <div className="flex items-center space-x-2 mb-1">
              <span className="text-sm font-mono text-indigo-600" title={demo.id || 'DEMO'}>
                {demo.id || 'DEMO'}
              </span>
              <span className="text-sm text-gray-500">•</span>
              <span className="text-sm font-medium text-gray-500">
                {dateTime?.timeSlot || 'Time not set'}
              </span>
            </div>
            <h3 className="text-lg font-medium text-gray-900">
              {customer?.name || 'New Demo'}
            </h3>
            <p className="text-sm text-gray-500 flex items-center">
              <UserIcon className="h-4 w-4 mr-1" />
              {customer?.mobile}
            </p>
          </div>
          <button 
            onClick={(e) => {
              e.stopPropagation();
              onAction?.(e);
            }}
            className="text-gray-400 hover:text-gray-500"
          >
            <EllipsisVerticalIcon className="h-5 w-5" />
          </button>
        </div>
        
        <div className="mt-4 space-y-2">
          <div className="flex items-center text-sm text-gray-600">
            <CalendarIcon className="h-4 w-4 mr-2 text-gray-400" />
            <span>{formatDate(dateTime?.demoDate)}</span>
          </div>
          <div className="flex items-center text-sm text-gray-600">
            <ClockIcon className="h-4 w-4 mr-2 text-gray-400" />
            <span>{getTimeSlot(dateTime?.timeSlot)}</span>
          </div>
          {location && (
            <div className="flex items-center text-sm text-gray-600">
              <MapPinIcon className="h-4 w-4 mr-2 text-gray-400" />
              <span className="truncate">{location}</span>
            </div>
          )}
        </div>
      </div>
      
      <div className="bg-gray-50 px-4 py-2 border-t border-gray-100">
        <div className="flex justify-between items-center">
          {payload?.hostedDemo?.isHosted === 'YES' && (
            <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-blue-100 text-blue-800">
              Hosted
            </span>
          )}
          <span className="text-xs text-gray-500">
            Booked on {new Date(payload?.dateTime?.timestamp).toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })}
          </span>
        </div>
      </div>
    </div>
  );
}
